export default __webpack_public_path__ + "static/media/Maheshwari-Saree.39c0e101.jpg";